/**
 * Mobile search overlay open/close.
 *
 *   - Click `.amri-mobile-search-btn` → open `#amri-mobile-search-overlay`.
 *   - Click `[data-overlay-control="close"]` → close.
 *   - ESC key → close.
 */

const OVERLAY_ID = 'amri-mobile-search-overlay';

function getOverlay(): HTMLElement | null {
    return document.getElementById(OVERLAY_ID);
}

export function closeSearchOverlay(): void {
    const overlay = getOverlay();
    if (!overlay) {
        return;
    }

    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
}

export function openSearchOverlay(): void {
    const overlay = getOverlay();
    if (!overlay) {
        return;
    }

    overlay.style.display = 'block';
    overlay.setAttribute('aria-hidden', 'false');

    const input = overlay.querySelector<HTMLInputElement>('input[type="search"]');
    if (input) {
        input.focus();
    }
}

function handleDocumentClick(e: Event): void {
    const target = e.target as HTMLElement | null;
    if (!target) {
        return;
    }

    if (target.closest('.amri-mobile-search-btn')) {
        e.preventDefault();
        openSearchOverlay();

        return;
    }

    if (target.closest('[data-overlay-control="close"]')) {
        e.preventDefault();
        closeSearchOverlay();
    }
}

function handleEscKey(e: KeyboardEvent): void {
    if (e.key === 'Escape') {
        closeSearchOverlay();
    }
}

export function initSearchOverlay(): void {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleEscKey);
}
